import React from "react";
//import PropTypes from 'prop-types';
import LocaleSelect from "./LocaleSelect";
import { useSelector } from "react-redux";
import { useActions, useRouteParam } from "state/hooks";
import { resetAll } from "state/actions/data";
import { selectLanguages } from "playground/cms/state/selectors/lang";

export function LocaleSelectContainer(props) {
    const { id } = props;
    const options = useSelector((state) => {
        return selectLanguages(state, id);
    });
    const [value, setValue] = useRouteParam("lang");
    const { onReset } = useActions({
        onReset: resetAll,
    });
    const change = (v) => {
        onReset();
        setValue(v);
    };
    return <LocaleSelect options={options} value={value} onChange={change} />;
}

LocaleSelectContainer.propTypes = {};

LocaleSelectContainer.defaultProps = {};

export default LocaleSelectContainer;
